import { useContext } from 'react';

import { UserContext } from '../UserContext';

const useUserData = () => useContext(UserContext);
export default useUserData;
